import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap"
import { Link } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import { connect } from "react-redux"
import cogoToast from 'cogo-toast';

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import Asset from './Asset'

const { ExportCSVButton } = CSVExport;


const Assets = props => {

  const [modal, setModal] = useState(false);

  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState([]);

  const [id, setId] = React.useState(null);
  const [deleteThis, setDeleteThis] = React.useState(null);
  const [forceDeleteThis, setForceDeleteThis] = React.useState(null);
  const [deleting, setDeleting] = React.useState(false);
  
  
  const toggleView = () => setId(null);
  const toggleDel = () => setDeleteThis(null);
  const toggleForceDel = () => setForceDeleteThis(null);

  const fetchData = () => {
    setLoading(true);
      console.log('RESP:');
      get(url.GET_ASSETS+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data);
        setLoading(false);
        }
      else {
        setData(null);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };


  React.useEffect(()=>{
    if(props.filterBlock) {
    fetchData();
    }
  }, [props.filterBlock]);

  const columns = [{
      dataField: 'slno',
      text: '#',
    }, {
      dataField: 'asset_code',
      text: 'Asset Code',
      sort: true,
      filter: textFilter(),
    }, {
    text: 'Asset Display Name',
    dataField: 'name',
    sort: true,
    filter: textFilter(),
    }, {
      text: 'Asset Display Location',
      dataField: 'room',
      sort: true,
      filter: textFilter(),
      formatter: (cell, row, rowIndex) => (row.building ? row.building.name+' / ' : '')+(row.floor ? row.floor.name+' / ' : '')+(row.room ? row.room.name : ''),
      filterValue: (cell, row, rowIndex) => (row.building ? row.building.name+' / ' : '')+(row.floor ? row.floor.name+' / ' : '')+(row.room ? row.room.name : ''),
      csvFormatter: (cell, row, rowIndex) => (row.building ? row.building.name+' / ' : '')+(row.floor ? row.floor.name+' / ' : '')+(row.room ? row.room.name : ''),
    }, {
    text: 'Asset Type',
    dataField: 'assettype.name',
    sort: true,
    filter: textFilter(),
    // formatter: ()=>'DG',
  }, {
    text: 'Asset Owner',
    dataField: 'owner',
    sort: true,
    filter: textFilter(),
  }, {
    text: 'Asset Status',
    dataField: 'asset_status',
    sort: true,
    filter: textFilter(),
  }, {
    text: 'Service Type',
    dataField: 'servicetype.name',
    // formatter: ()=>'-',
    sort: true,
    filter: textFilter(),
  }, 
  {
    text: 'Actions',
    dataField: 'id',
    formatter: (cell, row, rowIndex)=> {
      return <div className="d-flex">
        <Button color="link" title="View details" onClick={()=>{
          setId(row.id);
        }}>
          <i className="bx bx-info-circle" style={{color: '#667CE8', fontSize: 19,}}></i>
        </Button>{' '}
          <Link className="btn" to={{pathname: "/assets/edit/"+row.id, query: row}}>
            <i className="bx bx-pencil" style={{color: '#667CE8', fontSize: 19,}}></i>
          </Link>{' '}
        <Button color="link" title="Delete" onClick={()=>{
        setDeleteThis(row);
        }}><i className="bx bx-trash" style={{color: 'rgb(231, 119, 147)', fontSize: 19,}}></i></Button>
      </div>;
    },
    csvExport: false,
  },
  // {
  //   text: 'Actions',
  //   formatter: (cell, row, rowIndex)=> {
  //     return <div className="d-flex">
  //       <Button color="light" className="me-2" onClick={()=>{
  //       setId(row.id);
  //       }}>View</Button>{' '}
  //       <Link className="btn" to={{pathname: "/assets/edit/"+row.id, query: row}}>
  //         <i className="bx bx-pencil" style={{color: '#667CE8', fontSize: 19,}}></i>
  //       </Link>{' '}
  //     </div>;
  //   }
  // },
  ];

  const handleDelete = (force) => {
    let formdata = {
      id: force ? forceDeleteThis.id : deleteThis.id,
      force,
    };
    setDeleting(true);
    post(url.DELETE_ASSET, formdata)
    .then((response) => {
      console.log('DEL RESP', response);
      if(response.status == 200) {
        cogoToast.success('Asset deleted');
        setDeleteThis(null);
        setForceDeleteThis(null);
        fetchData();
      }
      else if(response.status == 409) {
        setForceDeleteThis(JSON.parse(JSON.stringify(deleteThis)));
        setDeleteThis(null);
      }
      else {
        console.log('err::', response);
        cogoToast.error('Asset could not be deleted');
      }
      setDeleting(false);
    }, (error) => {
      console.log(error);
      cogoToast.error('Asset could not be deleted');
      setDeleting(false);
    });

  };

  const createExportAllHandler = ({ onExport }) => () => {
    onExport(data);
  };


  const noData = <div className="text-muted py-3 text-center">{props.filterBlock ? 'No data to display' : "Please select Property and Block"}</div>

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Assets | Digital Logbook</title>
        </MetaTags>
        <Container fluid>

        <ToolkitProvider
            keyField="id"
            data={ data }
            columns={ columns }
            exportCSV={ {
              fileName: 'assets.csv',
              // separator: '|',
              // ignoreHeader: true,
              // noAutoBOM: false
              exportAll: false,
            } }
          >
            {
              props => (
          <React.Fragment>

            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-4">Assets ({data.length})</h3>
              <div className="d-flex justify-content-end align-items-center">
                <ExportCSVButton className="btn btn-secondary me-2" { ...props.csvProps } 
                  onClick={createExportAllHandler(props.csvProps) }  >Export All</ExportCSVButton>
                <ExportCSVButton className="btn btn-secondary me-2" { ...props.csvProps } 
                  >Export Visible</ExportCSVButton>
                <Link className="btn btn-primary" to="/assets/new">Create New</Link>
              </div>
            </div>

            <Card>
              <CardBody>
                {/* <CardTitle tag="h3">Forms</CardTitle> */}
                {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}

                <BootstrapTable 
                  { ...props.baseProps }
                  keyField='id'
                  data={ data }
                  filter={ filterFactory() }
                  pagination={ paginationFactory() } 
                  noDataIndication={noData}
                  />

                {/* <BootstrapTable keyField='id' data={ data } columns={ columns } filter={ filterFactory() } pagination={ paginationFactory() } /> */}
              </CardBody>
            </Card>

          </React.Fragment>
          )
        }
        </ToolkitProvider>

        </Container>
      </div>



      
      { id !== null &&
        <Asset id={id} isOpen={id !== null} toggle={toggleView} />
      }
      { deleteThis !== null &&
      <Modal isOpen={deleteThis !== null} centered>
        <ModalHeader toggle={toggleDel}>Confirmation</ModalHeader>
        <ModalBody>
          Are you sure you want to delete {deleteThis.name}?
          <br />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" disabled={deleting} onClick={()=>{handleDelete(false)}}>Delete</Button>{' '}
          <Button color="link" onClick={toggleDel}>Cancel</Button>
        </ModalFooter>
      </Modal>}
      
      { forceDeleteThis !== null &&
      <Modal isOpen={forceDeleteThis !== null} centered>
        <ModalHeader toggle={toggleForceDel}>Warning</ModalHeader>
        <ModalBody>
          Asset contains tasks. Deleting will also clear all the associated data.
          <br />
          Proceed? 
          <br />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" disabled={deleting} onClick={() => { handleDelete(true); }}>Yes, Delete</Button>{' '}
          <Button color="link" onClick={toggleForceDel}>Cancel</Button>
        </ModalFooter>
      </Modal>}

    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
  } = state.filters
  return { filterBlock }
}

export default connect(mapStatetoProps)(Assets)